// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b50bee9d","58":"80b0e8a5","162":"43ae3ad2","453":"d0f27d25"}[chunkId] + ".chunk.js";
};